import { createTheme, createTokenContract, css } from "dx-styles";

/// The app's own palette, lifted from `Web/design/Tokens.dc.html` — which in turn
/// lifted it from the iOS app. Subscribers move between the two surfaces, so they
/// have to look like one product.
export const tokens = createTokenContract(
  {
    color: {
      linen: null,
      paper: null,
      kraft: null,
      ink: null,
      pencil: null,
      rule: null,
      olive: null,
      signal: null,
      topo: null,
    },
    font: { body: null, mono: null },
    radius: { sm: null, md: null, lg: null },
    space: { xs: null, sm: null, md: null, lg: null, xl: null },
  },
  { prefix: "dit" },
);

export const theme = createTheme(tokens, {
  color: {
    linen: "#EFE9DC",
    paper: "#F7F3E9",
    kraft: "#EFE6D2",
    ink: "#33301F",
    pencil: "#6C6853",
    rule: "#D9D0BB",
    olive: "#6D7052",
    signal: "#B8470F",
    topo: "#9DB4BA",
  },
  font: {
    body: 'system-ui, -apple-system, "Helvetica Neue", sans-serif',
    mono: "ui-monospace, SFMono-Regular, Menlo, monospace",
  },
  radius: { sm: "6px", md: "10px", lg: "16px" },
  space: { xs: "4px", sm: "8px", md: "16px", lg: "24px", xl: "40px" },
});

export const globals = css({
  ":global()": {
    "*, *::before, *::after": { boxSizing: "border-box" },
    "html, body, #root": { height: "100%", margin: 0 },
    body: {
      backgroundColor: tokens.color.linen,
      color: tokens.color.ink,
      fontFamily: tokens.font.body,
      fontSize: "15px",
      lineHeight: 1.5,
      WebkitFontSmoothing: "antialiased",
    },
    "button, input, textarea": { font: "inherit", color: "inherit" },
    // Focus stays visible everywhere: Radix gives keyboard completeness, this
    // makes it legible.
    ":focus-visible": { outline: `2px solid ${tokens.color.signal}`, outlineOffset: "2px" },
    a: { color: tokens.color.olive },
  },
});
